import { CSSProperties } from "react";

/**
 * Static design tokens for **rendered email HTML** (React Email → Mailgun).
 *
 * These MUST remain hardcoded hex values — email clients (Gmail, Outlook, etc.)
 * do NOT support CSS custom properties (`var(--…)`). Every value here is inlined
 * into the final `<style>` / `style=""` attributes of the outgoing email.
 */
export const EMAIL_TOKENS = {
  fontFamily: {
    sans: "'Arial', 'Helvetica Neue', 'Helvetica', sans-serif",
    serif: "'Georgia', 'Times New Roman', 'Times', serif",
    mono: "'Courier New', 'Courier', monospace",
  },
  fontSize: {
    xs: "12px",
    sm: "14px",
    base: "16px",
    lg: "18px",
    xl: "22px",
    "2xl": "28px",
    "3xl": "36px",
  },
  lineHeight: {
    tight: "1.25",
    normal: "1.5",
    relaxed: "1.75",
  },
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
    "2xl": "48px",
  },
  colors: {
    text: {
      primary: "#1a1a1a",
      secondary: "#4b5563",
      muted: "#9ca3af",
      inverse: "#ffffff",
    },
    background: {
      primary: "#ffffff",
      secondary: "#f9fafb",
      tertiary: "#f3f4f6",
    },
    border: {
      default: "#e5e7eb",
      light: "#f3f4f6",
    },
    brand: {
      primary: "#006bb5",
      primaryHover: "#0055a0",
    },
  },
  borderRadius: {
    sm: "4px",
    md: "8px",
    lg: "12px",
    full: "9999px",
  },
} as const;

export const EMAIL_MIXINS = {
  textReset: {
    margin: "0",
    padding: "0",
    fontFamily: EMAIL_TOKENS.fontFamily.sans,
  } satisfies CSSProperties,

  link: {
    color: EMAIL_TOKENS.colors.brand.primary,
    textDecoration: "underline",
  } satisfies CSSProperties,

  responsiveImage: {
    maxWidth: "100%",
    height: "auto",
    display: "block",
  } satisfies CSSProperties,
};
